<template functional>
  <div class="network-indicator px-1 inline-flex align-center">
    <div
      class="network-indicator__status mr-1"
      :class="`bg-${$options.statusColor(props.networkId)}`"
    ></div>
    {{ $options.network(props.networkId) }}
  </div>
</template>

<script>
const NETWORK_ID = process.env.VUE_APP_NETWORK_ID || "3"

const networks = {
  "1": "Main Ethereum Network",
  "3": "Ropsten Network",
  "4": "Rinkeby Network",
  "5": "Görli Network",
  "42": "Kovan Network"
}

export default {
  props: {
    networkId: {
      validator: prop => prop === null || typeof prop === "string",
      required: true
    }
  },

  network(networkId) {
    if (!networkId) return "Not Connected"
    return networks[networkId] || "Unknown Network"
  },

  statusColor(networkId) {
    switch (networkId) {
      case NETWORK_ID:
        return "green"
      case null:
        return "grey"
      default:
        return "red"
    }
  }
}
</script>

<style lang="scss">
.network-indicator {
  border: 1px solid rgba($highlight, 0.5);
  border-radius: 100px;

  &__status {
    width: rem(10px);
    height: rem(10px);
    border-radius: 50%;
  }
}
</style>
